import vpsOciTypes from './vpsOci.types';

export const initialState = {
  data: {
    packageId: null,
    productName: '',
    serverInfo: {
      locked: false,
      reason: '',
    },
    vps: {
      domain: '',
      serverIp: '',
      datacenter: '',
      processor: '',
      memory: '',
      disk: '',
      hasPassword: true,
    },
    ssh: {
      serverIp: '',
      serverPort: '',
      user: '',
    },
    management: [],
    details: {
      registerDate: null,
      nextDueDate: null,
      billingCycle: '',
      paymentMethod: '',
    },
    addons: [],
    availableOptions: {
      operationalSystems: [],
      panels: [],
      applications: [],
    },
  },
  loading: false,
  isRebooting: false,
  status: {
    loading: false,
    value: '',
  },
  tour: {
    canShowTour: false,
  },
  rebuild: {
    loading: false,
    status: '',
  },
  changeImage: {
    loading: false,
    data: {},
    status: '',
  },
  openSshTerminal: {
    loading: false,
    url: null,
  },
  password: {
    loading: false,
    success: false,
  },
  upgrade: {
    listing: {
      loading: false,
      data: null,
    },
    details: {
      loading: false,
      data: null,
    },
    submit: {
      loading: false,
      data: {},
    },
  },
  openClaw: {
    loading: false,
    success: false,
  },
  gatorClaw: {
    loading: false,
    success: false,
  },
  sshKeys: {
    fetch: {
      data: null,
      loading: false,
      error: null,
    },
    create: {
      loading: false,
      error: null,
      success: false,
    },
    delete: {
      loading: false,
      error: null,
      success: false,
    },
  },
};

const vpsOciReducer = (state = initialState, action) => {
  switch (action.type) {
    case vpsOciTypes.GET_VPS_OCI_REQUEST:
      if (state.loading) return state;
      return { ...state, loading: true };
    case vpsOciTypes.SET_VPS_OCI_DATA:
      return { ...state, ...action.payload };
    case vpsOciTypes.VPS_OCI_SET_LOADING:
      if (state.loading === action.payload) return state;
      return { ...state, loading: action.payload };

    case vpsOciTypes.STATUS_VPS_OCI_REQUEST:
      if (state.status.loading) return state;
      return { ...state, status: { ...state.status, loading: true } };
    case vpsOciTypes.STATUS_VPS_OCI_DATA:
      if (state.status.value === action.payload) return state;
      return { ...state, status: { ...state.status, value: action.payload } };
    case vpsOciTypes.STATUS_VPS_OCI_LOADING:
      if (state.status.loading === action.payload) return state;
      return { ...state, status: { ...state.status, loading: action.payload } };

    case vpsOciTypes.REBOOT_VPS_SET_LOADING:
      if (state.isRebooting === action.payload) return state;
      return { ...state, isRebooting: action.payload };

    case vpsOciTypes.REBUILD_VPS_REQUEST:
      return { ...state, rebuild: { ...state.rebuild, loading: true, status: '' } };
    case vpsOciTypes.REBUILD_VPS_SET_LOADING:
      if (state.rebuild.loading === action.payload) return state;
      return { ...state, rebuild: { ...state.rebuild, loading: action.payload } };
    case vpsOciTypes.REBUILD_VPS_SET_STATUS:
      if (state.rebuild.status === action.payload) return state;
      return { ...state, rebuild: { ...state.rebuild, status: action.payload } };
    case vpsOciTypes.REBUILD_VPS_RESET:
      return { ...state, rebuild: { ...initialState.rebuild } };

    case vpsOciTypes.CHANGE_IMAGE_VPS_REQUEST:
      return { ...state, changeImage: { ...state.changeImage, loading: true } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_LOADING:
      if (state.changeImage.loading === action.payload) return state;
      return { ...state, changeImage: { ...state.changeImage, loading: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_STATUS:
      if (state.changeImage.status === action.payload) return state;
      return { ...state, changeImage: { ...state.changeImage, status: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_SET_DATA:
      return { ...state, changeImage: { ...state.changeImage, data: action.payload } };
    case vpsOciTypes.CHANGE_IMAGE_VPS_RESET:
      return { ...state, changeImage: { ...initialState.changeImage } };

    case vpsOciTypes.SAVE_SSH_PASSWORD_SET_LOADING:
      if (state.password.loading === action.payload) return state;
      return { ...state, password: { ...state.password, loading: action.payload } };
    case vpsOciTypes.SAVE_SSH_PASSWORD_SET_SUCCESS:
      if (state.password.success === action.payload) return state;
      return { ...state, password: { ...state.password, success: action.payload } };

    case vpsOciTypes.OPEN_SSH_TERMINAL_SET_LOADING:
      if (state.openSshTerminal.loading === action.payload) return state;
      return { ...state, openSshTerminal: { ...state.openSshTerminal, loading: action.payload } };
    case vpsOciTypes.OPEN_SSH_TERMINAL_SET_DATA:
      if (state.openSshTerminal.url === action.payload) return state;
      return { ...state, openSshTerminal: { ...state.openSshTerminal, url: action.payload } };

    case vpsOciTypes.SET_TOUR_DATA:
      if (state.tour.canShowTour === action.payload) return state;
      return { ...state, tour: { ...state.tour, canShowTour: action.payload } };

    case vpsOciTypes.SET_LOADING_LISTING_UPGRADE_VPS_OCI:
      if (state.upgrade.listing.loading === action.payload) return state;
      return { ...state, upgrade: { ...state.upgrade, listing: { ...state.upgrade.listing, loading: action.payload } } };
    case vpsOciTypes.SET_DATA_LISTING_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, listing: { ...state.upgrade.listing, data: action.payload } } };

    case vpsOciTypes.SET_DATA_DETAILS_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, details: { ...state.upgrade.details, data: action.payload } } };
    case vpsOciTypes.SET_LOADING_DETAILS_UPGRADE_VPS_OCI:
      if (state.upgrade.details.loading === action.payload) return state;
      return { ...state, upgrade: { ...state.upgrade, details: { ...state.upgrade.details, loading: action.payload } } };

    case vpsOciTypes.SET_LOADING_UPGRADE_VPS_OCI:
      if (state.upgrade.submit.loading === action.payload) return state;
      return { ...state, upgrade: { ...state.upgrade, submit: { ...state.upgrade.submit, loading: action.payload } } };
    case vpsOciTypes.SET_DATA_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...state.upgrade, submit: { ...state.upgrade.submit, data: action.payload } } };
    case vpsOciTypes.RESET_UPGRADE_VPS_OCI:
      return { ...state, upgrade: { ...initialState.upgrade } };


    case vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_LOADING:
      if (state.openClaw.loading === action.payload) return state;
      return { ...state, openClaw: { ...state.openClaw, loading: action.payload } };
    case vpsOciTypes.SAVE_TOKEN_OPENCLAW_SET_SUCCESS:
      if (state.openClaw.success === action.payload) return state;
      return { ...state, openClaw: { ...state.openClaw, success: action.payload } };

    case vpsOciTypes.CONFIGURE_GATORCLAW_SET_LOADING:
      if (state.gatorClaw.loading === action.payload) return state;
      return { ...state, gatorClaw: { ...state.gatorClaw, loading: action.payload } };
    case vpsOciTypes.CONFIGURE_GATORCLAW_SET_SUCCESS:
      if (state.gatorClaw.success === action.payload) return state;
      return { ...state, gatorClaw: { ...state.gatorClaw, success: action.payload } };

    case vpsOciTypes.FETCH_SSH_KEY_REQUEST:
      return { ...state, sshKeys: { ...state.sshKeys } };
    case vpsOciTypes.FETCH_SSH_KEY_LOADING:
      if (state.sshKeys.fetch.loading === action.payload) return state;
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          fetch: { ...state.sshKeys.fetch, loading: action.payload },
        },
      };
    case vpsOciTypes.FETCH_SSH_KEY_SUCCESS:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          fetch: {
            data: action.payload,
            error: null,
            loading: false,
          },
        },
      };
    case vpsOciTypes.FETCH_SSH_KEY_FAILURE:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          fetch: {
            ...state.sshKeys.fetch,
            error: action.payload,
            loading: false,
          },
        },
      };

    case vpsOciTypes.CREATE_SSH_KEY_REQUEST:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          create: { ...state.sshKeys.create, loading: true, success: false },
        },
      };
    case vpsOciTypes.CREATE_SSH_KEY_LOADING:
      if (state.sshKeys.create.loading === action.payload) return state;
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          create: { ...state.sshKeys.create, loading: action.payload },
        },
      };
    case vpsOciTypes.CREATE_SSH_KEY_SUCCESS:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          create: {
            error: null,
            loading: false,
            success: true,
          },
        },
      };
    case vpsOciTypes.CREATE_SSH_KEY_FAILURE:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          create: {
            error: action.payload,
            loading: false,
            success: false,
          },
        },
      };

    case vpsOciTypes.DELETE_SSH_KEY_REQUEST:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          delete: { ...state.sshKeys.delete, loading: true, success: false },
        },
      };
    case vpsOciTypes.DELETE_SSH_KEY_LOADING:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          delete: { ...state.sshKeys.delete, loading: action.payload },
        },
      };
    case vpsOciTypes.DELETE_SSH_KEY_SUCCESS:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          delete: {
            error: null,
            loading: false,
            success: true,
          },
        },
      };
    case vpsOciTypes.DELETE_SSH_KEY_FAILURE:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          delete: {
            error: action.payload,
            loading: false,
            success: false,
          },
        },
      };

    case vpsOciTypes.FETCH_SSH_KEY_RESET:
      return {
        ...state,
        sshKeys: { ...initialState.sshKeys },
      };

    case vpsOciTypes.CREATE_SSH_KEY_RESET:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          create: { ...initialState.sshKeys.create },
        },
      };

    case vpsOciTypes.DELETE_SSH_KEY_RESET:
      return {
        ...state,
        sshKeys: {
          ...state.sshKeys,
          delete: { ...initialState.sshKeys.delete },
        },
      };

    default:
      return state;
  }
};

export default vpsOciReducer;
